import { LinearGradient } from "expo-linear-gradient";
import { useUnistyles } from "react-native-unistyles";
import { FC, memo, ReactNode } from "react";

type BackgroundGradientProps = {
  children: ReactNode;
};

export const BackgroundGradient: FC<BackgroundGradientProps> = memo(({ children }) => {
  const { theme } = useUnistyles();

  return (
    <LinearGradient
      colors={[theme.colors.navy[900], theme.colors.navy[700]]}
      start={{ x: 1, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={{ flex: 1 }}
    >
      {children}
    </LinearGradient>
  );
});
